/* Copyright 2015 VMware, Inc. All rights reserved. -- VMware Confidential */
angular.module('com.vmware.platform.ui')
   .service('timeFormatterService', ['i18nService', 'localStorageService', 'browserLanguage',
      function(i18nService, localStorageService, browserLanguage) {
         'use strict';
         var BROWSER_DEFAULT =  {
            id: 'DateTimeBrowserDefault',
            displayName: i18nService.getString('Common', 'changeDateTimeFormat.BrowserDefault.label')
         };

         var FORMAT_12_HOUR =  {
            id: 'DateTimeFormat12',
            displayName: i18nService.getString('Common', 'changeDateTimeFormat.12Hour.label')
         };

         var FORMAT_24_HOUR = {
            id: 'DateTimeFormat24',
            displayName: i18nService.getString('Common', 'changeDateTimeFormat.24Hour.label')
         };

         var KNOWN_FORMATS = [BROWSER_DEFAULT, FORMAT_12_HOUR, FORMAT_24_HOUR];
         var DEFAULT_FORMAT = BROWSER_DEFAULT;
         var TIMEDATE_LOCALSTORAGE_KEY = 'timeFormat';

         var userTimeFormatPreference = function() {
            return localStorageService.getUserData(TIMEDATE_LOCALSTORAGE_KEY).then(function(savedFormatId) {
               return findDateTimeFormat(savedFormatId);
            });
         };

         function findDateTimeFormat(format) {
            var foundFormat = _.find(KNOWN_FORMATS, function(knownFormat) {
               return knownFormat.id === format;
            });
            return foundFormat || DEFAULT_FORMAT;
         }

         function formatIsKnown(format) {
            return _.find(KNOWN_FORMATS, function(knownFormat) {
               return format && format.id && format.id === knownFormat.id;
            });
         }

         var defaultOptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
         };
         var defaultFormatter =
               Intl.DateTimeFormat(browserLanguage.get(), defaultOptions);
         defaultOptions.hour12 = false;
         var formatter24 =
               Intl.DateTimeFormat(browserLanguage.get(), defaultOptions);

         function timestamp2txt(timestamp, savedDateTimeFormat, options) {
            // Convert timestamp to number or NaN. "+ timestamp" will return NaN
            // for any invalid value such as: '3.14p', '3,14p', '3,14' and any other non-numeric value.
            // Invalid timestamps cause a lot of errors in the client. Please see VSUIP-2550.
            var numberTimestamp = timestamp ? + timestamp : NaN;
            if (!(typeof numberTimestamp === 'number' && isFinite(numberTimestamp))) {
               return '';
            }
            delete defaultOptions.hour12;
            options = options || defaultOptions;

            if (!('hour12' in options)
                  && savedDateTimeFormat
                  && savedDateTimeFormat !== BROWSER_DEFAULT) {
               options.hour12 = savedDateTimeFormat.id === FORMAT_12_HOUR.id;
            }
            if (!('hour12' in options) || options.hour12) {
               return defaultFormatter.format(new Date(numberTimestamp));
            } else {
               return formatter24.format(new Date(numberTimestamp));
            }
         }

         function formatDate(timestamp, options) {
            return userTimeFormatPreference().then(function(savedDateTimeFormat) {
               return timestamp2txt(timestamp, savedDateTimeFormat, options);
            });
         }

         return {
            formatDate: formatDate,
            timestampToText: timestamp2txt,
            setUserTimeFormatPreference: function(dateTimeFormat) {
               if (formatIsKnown(dateTimeFormat)) {
                  localStorageService.setUserData(TIMEDATE_LOCALSTORAGE_KEY, dateTimeFormat.id);
               }
            },
            getUserTimeFormatPreference: userTimeFormatPreference,
            getKnownFormats: function() {
               return KNOWN_FORMATS;
            }
         };
      }
   ]);
